export interface Category {
  id: string;
  name: string;
  tagline: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: "yule",
    name: "娱乐八卦",
    tagline: "圈内趣闻连连看",
    desc: "综艺现场、剧组花絮、红毯造型与台前幕后的高能瞬间。",
    icon: "ri-vip-crown-fill",
    count: 1826,
  },
  {
    id: "mingxing",
    name: "明星爆料",
    tagline: "一线动态早知道",
    desc: "路透生图、行程现场、采访幕后，第一时间掌握明星动态。",
    icon: "ri-star-smile-fill",
    count: 1540,
  },
  {
    id: "shehui",
    name: "社会事件",
    tagline: "身边暖闻在发生",
    desc: "正能量暖闻、公共话题、城市记录，关注真实社会百态。",
    icon: "ri-earth-fill",
    count: 986,
  },
  {
    id: "wanghong",
    name: "网红日常",
    tagline: "热门达人全追踪",
    desc: "直播高光、探店日常、创作者幕后，追踪热门达人最新动态。",
    icon: "ri-live-fill",
    count: 1230,
  },
  {
    id: "gaoxiao",
    name: "搞笑合集",
    tagline: "每天笑到停不下来",
    desc: "神反转、挑战名场面、爆笑合集，承包你一整天的快乐。",
    icon: "ri-emotion-laugh-fill",
    count: 2110,
  },
  {
    id: "hipai",
    name: "实拍现场",
    tagline: "真实镜头零距离",
    desc: "现场直击、第一视角、震撼运镜，还原镜头背后的真实场景。",
    icon: "ri-camera-3-fill",
    count: 764,
  },
];

export const categoryName = (id: string): string => {
  const c = categories.find((item) => item.id === id);
  return c ? c.name : "娱乐八卦";
};